












































import Vue from "vue";
import CustomTable from "@/components/Table/table.vue";
import CustomCheckbox from "@/components/Input/Checkbox.vue";
import { DataTableHeader } from "vuetify";
import { DeviceDescriptionDataTable } from "@/types/types";
import { store } from "@/store/store";
import router from "@/router/router";

interface DeviceDescriptionTable {
  headers: Array<DataTableHeader>;
  items_displayed: Array<string>;
}

export default Vue.extend({
  name: "DeviceDescriptionTable",
  components: { CustomTable, CustomCheckbox },
  props: {
    selected: {
      type: Array as () => Array<string>
    },
    shouldDisplayDescriptionPanel: {
      type: Function
    },
    onSelectChange: {
      type: Function
    },
    searchFilter: {
      type: Object
    },
    loading: {
      type: Boolean
    },
    material_id: {
      type: String
    }
  },
  data(): DeviceDescriptionTable {
    return {
      headers: [
        { text: "", value: "selected", sortable: false },
        { text: "Nom", value: "name_poste", align: "center" },
        { text: "Typologie", align: "center", value: "typology" },
        { text: "Campagne", value: "survey_name", align: "center" },
        { text: "Campagne id budget", value: "survey_id_budget", align: "center" }
      ],
      items_displayed: []
    };
  },
  methods: {
    format_data(): Array<DeviceDescriptionDataTable> {
      let data_array: Array<DeviceDescriptionDataTable> = [];
      store.getters.POSTE_ALL_ID.forEach((poste_id) => {
        const poste = store.getters.POSTE_BY_ID[poste_id];
        if (poste.material === this.material_id) {
          let p: DeviceDescriptionDataTable = {
            ...poste,
            typology: poste.typology.toUpperCase(),
            survey_name: store.getters.SURVEY_BY_ID[poste.survey]?.name_survey,
            survey_id_budget: store.getters.SURVEY_BY_ID[poste.survey]?.id_budget
          };
          data_array.push(p);
        }
      });
      return data_array;
    },
    CheckIfSelected(_id: string): boolean {
      return this.selected.findIndex((selected_item) => selected_item === _id) !== -1;
    },
    selectedToggleAll(selected: boolean): void {
      this.onSelectChange(selected ? [...this.items_displayed] : []);
    },
    selectedChange(_id: string): void {
      let selected_copy = [...this.selected];
      const found_id = selected_copy.findIndex((select: string) => select === _id);
      found_id !== -1 ? selected_copy.splice(found_id, 1) : selected_copy.push(_id);
      this.onSelectChange(selected_copy);
    },
    currentItems(items: Array<any>) {
      this.items_displayed = items.map((item) => item._id) as Array<string>;
    },
    redirectToCampaign(_id: string): void {
      router.push({ path: `/survey?surveyId=${_id}` });
    },
    redirectToPoste(item: any): void {
      router.push({ path: `/poste?posteId=${item._id}` });
    }
  }
});
